import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type * as models from '../../models'
import { transformUsersToAgentAssignments } from '../shared'

const DOC = gql`
  query AgentAssignmentsInTenant($tenantId: ID!) {
    tenant(id: $tenantId) {
      users {
        items {
          info {
            id
            firstName
            lastName
          }
          agents {
            id
            access
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AgentAssignmentsInTenantQuery,
    readonly models.AgentAssignment[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'users',
      graphql.transformers.OUT.custom(transformUsersToAgentAssignments),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.AgentAssignmentsInTenantQuery,
  readonly models.AgentAssignment[],
  graphql.schema.AgentAssignmentsInTenantQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
